import { render, staticRenderFns } from "./HabitsSetup.vue?vue&type=template&id=63b8aafe&scoped=true&"
import script from "./HabitsSetup.vue?vue&type=script&lang=js&"
export * from "./HabitsSetup.vue?vue&type=script&lang=js&"
import style0 from "./HabitsSetup.vue?vue&type=style&index=0&id=63b8aafe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8aafe",
  null
  
)

export default component.exports